import { render, staticRenderFns } from "./package_info.vue?vue&type=template&id=57f73986&"
import script from "./package_info.vue?vue&type=script&lang=js&"
export * from "./package_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports